<template>
  <router-view></router-view>
</template>

<script>
import store from "./_store";
import applicantProfileStore from "../ApplicantProfile/_store";

/**
 * @module MoodleCourse
 * @description manage form templates
 */
export default {
  /**
   * @memberof module:MoodleCourse
   * @namespace components
   * @description components of moodle courses module
   */
  components: {},
  created() {
    const STORE_KEY = "$_moodle_course";
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    const APPLICANT_PROFILE_STORE_KEY = "$_applicant_profile";
    if (!(APPLICANT_PROFILE_STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(
        APPLICANT_PROFILE_STORE_KEY,
        applicantProfileStore
      );
    }
  },
};
</script>
